const anime = require("animejs");

function animations(parentContainer = document, className = "animations") {

    const header = document.getElementById("content-bg");
    const subHeader = document.getElementById("sub-header");

    if (header != undefined) {

        //animateHeaderCurves();

        let headerBg = document.getElementById("content-bg");
        let content = document.getElementById("header-content-box");
        let curves = document.getElementById("curves");
        let w = window.innerWidth;
        let width = '45%';

        if (w < 1500 && w > 1200) {
            width = '55%';
        } else if (w < 1200 && w > 800) {
            width = '65%';
        } else if (w < 800) {
            width = '100%';
        }

        hasRunned = false;
        anime({
            targets: headerBg,
            width: ['0px', width],
            duration: 1200,
            elasticity: 100,
            update: function(anim) {
                if (anim.progress > 30) {
                    if (hasRunned == false) {
                        hasRunned = true;
                        showItems();
                    }
                }
            },
            complete: function(anim) {
                headerBg.removeAttribute('style');
                headerBg.style.minWidth = '430px';
                headerBg.className += " width-controller";
            }
        });

    } else if (subHeader != undefined) {

        const original = ['M0,112.1c0,0,381.4,211.9,762.7,176.7C1138.6,263.5,1662.3-74,1918.9,20.7v358.8H0V112.1z', 'M0.8,145.3c0,0,381.4,211.9,762.7,176.7C1139.3,296.7,1663-40.7,1919.7,53.9l-0.8,325.5H0L0.8,145.3z', 'M0,181.1c0,0,381.4,211.9,762.7,176.7c375.9-25.3,899.6-375.3,1156.2-280.7v302.2H0V181.1z'];
        const flat = ['M0,379.4c0,0,381.4,26.1,762.7-9c375.9-25.3,899.6-85.6,1156.2,9l0,0H0L0,379.4z', 'M0,379.4c0,0,381.4,26.1,762.7-9c375.9-25.3,899.6-85.6,1156.2,9l0,0H0L0,379.4z', 'M0,379.4c0,0,381.4,26.1,762.7-9c375.9-25.3,899.6-85.6,1156.2,9l0,0H0L0,379.4z'];

        const curvePaths = ['M0,497.21S487.67,620.35,933.76,390.33,1679.48,127.79,1920,183.55V580.9H0V497.21Z', 'M0,399.63S550.4,634.29,1026.7,278.81,1920,134.76,1920,134.76V580.9H0V399.63Z', 'M0,360.13S511.61,542.48,929.2,256.05C1120.68,124.71,1537.56,-104,1920,55.76V580.9H0V360.13Z'];
        const curvePathsLoop = ['M0,430.21S487.67,600.35,900.76,370.33,1679.48,147.79,1920,170.55V580.9H0V497.21Z', 'M0,400.63S620.4,554.29,1026.7,278.81,1920,134.76,1920,134.76V580.9H0V399.63Z', 'M0,380.13S511.61,552.48,929.2,256.05C1120.68,124.71,1337.56,-84,1920,95.76V580.9H0V360.13Z'];

        // Function to animate an svg path from the selector, new path and a delay
        function curveAnimation(selector, path, delay) {
            hasRunned = false;
            anime({
                targets: selector,
                d: path,
                delay: delay,
                elasticity: 1,
                duration: 1000,
                complete: function(anim) {
                    // if (anim.progress > 10) {
                    //     if (hasRunned == false) {
                    //         hasRunned = true;
                    //         showItems();
                    //     }
                    // }
                }
            });
        }

        /**
         * Animate the three curves in the header
         */
        function animateHeaderCurves() {
            curveAnimation('#curve0', original[0], 50);
            curveAnimation('#curve1', original[1], 100);
            curveAnimation('#curve2', original[2], 150);
        }

        animateHeaderCurves();

        showItems();

    }

    function hasClass(target, className) {
        return new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);
    }

    // setTimeout(function(){
    // 	console.log('Running');
    // 	var parent = document.querySelectorAll('.content-wrap');
    // 	showItems(parent);
    // },2000);

    function showItems(parent = '') {
    	if(parent != '' || parent != null || parent != undefined){
        	var elements = document.querySelectorAll('.animate');
        }else {
        	var elements = document.querySelectorAll(parent + ' .animate');
        }
        Array.prototype.forEach.call(elements, function(el, i) {

            if (hasClass(elements[i], 'slide-in')) {
                anime({
                    targets: elements[i],
                    opacity: [0, 1],
                    translateY: [10*(i+1), 0],
                    duration: 700,
                    easing: 'easeOutCubic',
                    delay: 120 * i
                });
            } else if (hasClass(elements[i], 'fade-in')) {
                anime({
                    targets: elements[i],
                    opacity: [0, 1],
                    duration: 700,
                    easing: 'easeOutCubic',
                    delay: 120 * i
                });
            } else if (hasClass(elements[i], 'pop-in')) {
                anime({
                    targets: elements[i],
                    opacity: [0, 1],
                    scale: [0.7, 1],
                    duration: 800,
                    elasticity: 50,
                    delay: 120 * i
                });
            } else {
                console.log('!!! {'+elements[i] + ' is missing animate class} !!!')
            }

        });
    }

}

module.exports = animations;


// WEBPACK FOOTER //
// ./resources/js/modules/animations.js